export default __webpack_public_path__ + "static/media/Crow Shadow Gauntlets.7ae06359.jpg";